// extracted by mini-css-extract-plugin
module.exports = {"title":"PlanBuyContainer_title__1dcDf"};